export const ALLOWED_EXTENSIONS = [
    // Images
    'bmp',
    'gif',
    'heic-sequence',
    'heic',
    'heif-sequence',
    'heif',
    'ico',
    'jpeg',
    'jpg',
    'png',
    'svg',
    'webp',
    'tiff',
    'tif',
    'psd',
    'ai',
    'eps',
    'raw',
    // Videos
    '3gp',
    'aac',
    'avi',
    'flv',
    'hevc',
    'm4a',
    'm4v',
    'mkv',
    'mov',
    'mp4',
    'ogv',
    'webm',
    'wma',
    'wmv',
    // Audio
    'mp3',
    'wav',
    'flac',
    'ogg',
    'aiff',
    // Documents
    '7z',
    'csv',
    'doc',
    'docx',
    'htm',
    'html',
    'json',
    'pdf',
    'ppt',
    'pptx',
    'rar',
    'txt',
    'xls',
    'xlsx',
    'xml',
    'yaml',
    'yml',
    'zip',
    'rtf',
    'odt',
    'ods',
    'odp',
    'pages',
    'numbers',
    'key',
    // Design/Development
    'sketch',
    'fig',
    'css',
    'scss',
    'less',
];